import { render, staticRenderFns } from "./BillboardListHome.vue?vue&type=template&id=20322426&scoped=true&"
import script from "./BillboardListHome.vue?vue&type=script&lang=ts&"
export * from "./BillboardListHome.vue?vue&type=script&lang=ts&"
import style0 from "./BillboardListHome.vue?vue&type=style&index=0&id=20322426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20322426",
  null
  
)

export default component.exports